<script>
    import { MaterialApp, Container, Subheader, Divider, AppBar, ButtonGroup, ButtonGroupItem, Icon, Button, Checkbox, Select, Row, Col, TextField, Card, CardTitle, Dialog, CardActions, CardText, ListItem, List, Textarea, Menu, Badge, Switch } from 'svelte-materialify/src';
    import { mdiTooltip, mdiLasso, mdiSelectDrag, mdiArrowExpandAll, mdiFilter, mdiViewGrid, mdiPalette, mdiCubeScan, mdiInformation, mdiDatabaseRefresh, mdiDelete, mdiClose, mdiContentSave, mdiPlus, mdiMinus, mdiCommentTextOutline, mdiDatabaseExport, mdiDatabaseImport } from "@mdi/js";

    import * as d3 from "d3";
    import textures from "textures";
    import * as hagrid from "@saehrimnir/hagrid";
    import * as druid from "@saehrimnir/druidjs/dist/druid.js";
    import { onMount } from "svelte";
    import legend from "d3-svg-legend";
    import { Delaunay } from "d3-delaunay";
    import Dexie from "dexie";
    import "dexie-export-import";
    import jStat from "jstat";
    let db;


    let main;
    let width = 1;
    let height = 1;
    const margin = 80;
    const legend_margin = 10;
    $: aspect_ratio = width / height;

    let data = [];

    let projectionBy = "all";
    $: position_data = projectionBy == "all" ? data.map(({x, y}) => [x, y]) : (projectionBy == "issues" ? data.map(({x_issues: x, y_issues: y}) => [x, y]) : data.map(({x_helpful: x, y_helpful: y}) => [x, y]))

    let gridify_with = "hilbert";

    $: projection = gridify_with == "none" ? position_data : (gridify_with == "hilbert" ? hagrid.gridify(position_data) : hagrid.gridify(position_data, "dgrid", {"aspect_ratio": aspect_ratio}));
    $: delaunay = Delaunay.from(projection, d => x(d[0]), d => y(d[1]))//.voronoi([0, 0, width, height])
    $: x = d3.scaleLinear().domain([0, d3.max(projection, d => d[0]) + 1]).rangeRound([margin, width - margin])
    $: y = d3.scaleLinear().domain([0, d3.max(projection, d => d[1]) + 1]).rangeRound([margin, height - margin])
    $: w = gridify_with == "none" ? 15 : Math.abs(x(1) - x(0))
    $: h = gridify_with == "none" ? w / aspect_ratio : Math.abs(y(1) - y(0))

    let colorBy = "year";
    $: c = (i, t, f) => {
        switch (t) {
            case "year":
                return scales[t](f ?? data[i].original_image.slice(0, 4))
            default: 
                return scales[t](f ?? data[i][t]);
        }
    }

    let accessible_color = "#479fb5" //d3.interpolatePurples(.2) // "#b7ffc4"; // "steelblue" // "#117733"
    let borderline_color = "#0a5f93" // d3.interpolatePurples(.5) // "#918cff" // "lemonchiffon" // "#cc6677"
    let not_accessible_color = "#252961" // d3.interpolatePurples(1) //"#800000" //"indianred" // "#661100"
   /*  {
                "Accessible": "#c0d9f2",
                "Borderline": "#6daed5",
                "Not_Accessible": "#08306b",
            } */
/* 
    "year": d3.scaleOrdinal(d3.schemeTableau10).domain([2000, 2005, 2010, 2015, 2019]),
        "papertype": d3.scaleOrdinal(d3.schemeTableau10).domain(["SciVis", "InfoVis", "VAST", "VIS"]),
        "condition": d3.scaleOrdinal(d3.schemeTableau10).domain(['Deuteranomaly', 'Monochromacy', 'Protanomaly', 'Tritanomaly']), */

    $: scales = {
        "rating": d3.scaleOrdinal().domain( ["Accessible", "Borderline", "Not_Accessible"]).range([accessible_color, borderline_color, not_accessible_color]),
        "year": d3.scaleOrdinal([0.2, 0.4, 0.6, 0.8, 1].map(d3.interpolatePurples)).domain([2000, 2005, 2010, 2015, 2019]),
        "papertype": d3.scaleOrdinal(d3.schemeTableau10).domain(["SciVis", "InfoVis", "VAST", "VIS"]),
        "condition": d3.scaleOrdinal(["#9f003e", "#74a032", "#006bf3", "rgb(0, 0, 0)"]).domain(['Protanomaly', 'Deuteranomaly', 'Tritanomaly', 'Monochromacy']),
        'Accessible': d3.scaleLinear().domain([0, 1]).range([d3.hcl("white"), d3.hcl(accessible_color)]), 
        'Borderline': d3.scaleLinear().domain([0, 1]).range([d3.hcl("white"), d3.hcl(borderline_color)]), 
        'Not_Accessible': d3.scaleLinear().domain([0, 1]).range([d3.hcl("white"), d3.hcl(not_accessible_color)]), 
    }


    const issues_names = ['resolution_too_low', 'shapes_too_thinsmall',
                                'issues_with_text_size_or_font', 'text_broken',
                                'brightness_contrast_too_low', 'colors_not_distinguishable',
                                'colors_barely_distinguishable', 'continous_color_scale_ambiguos',
                                'highlighted_elements_do_not_pop_out',
                                'loss_of_detailed_information_content', 'fabricated_information'];
    const helpful_names = ['works_with_one_color', 'has_labels', 'descriptive_text',
                'texture_helps', 'colors_dont_change', 'order_helps'];

    const all_names = issues_names.concat(helpful_names);

    const names_dict = {
        'resolution_too_low' : "lores", 
        'shapes_too_thinsmall': "thin",
        'issues_with_text_size_or_font': "textize", 
        'text_broken': "brotex",
        'brightness_contrast_too_low': "locont", 
        'colors_not_distinguishable': "colnodi",
        'colors_barely_distinguishable': "colbadi", 
        'continous_color_scale_ambiguos': "scambi",
        'highlighted_elements_do_not_pop_out': "hinopo",
        'loss_of_detailed_information_content': "infloss", 
        'fabricated_information': "fabinf",
        'works_with_one_color': "singcol", 
        'has_labels': "labels", 
        'descriptive_text': "desc",
        'texture_helps': "texture", 
        'colors_dont_change': "colstay", 
        'order_helps': "order",
    }

    onMount(async() => {
        db = new Dexie("accesibilityStudy");
        db.version(1).stores({
            second: "++id,annotations"
        });

        [width, height] = [window?.innerWidth, window?.innerHeight - 64]
        data = await d3.csv(`${window.location.href}data/2021_08_projection.csv`, d3.autoType);
        for (let i = 0; i < data.length; ++i) {
            data[i].iii = i;
        }

        conditions = Array.from(new Set(data.map(d => d.condition)));
        filter_group = conditions.slice();

        console.log(data)
        draw_legend(colorBy)
        zoom = d3.zoom()
            .extent([[0, 0], [width, height]])
            .scaleExtent([0.5, 8])
            .on("zoom", zoomed);
        d3.select(viewerSvg).call(zoom);  

        annotations = await load_db();
        console.log(annotations);


        const accessible_texture = textures.lines().orientation("2/8").shapeRendering("crispEdges").size(2).lighter(2).stroke(d3.color(c(null, "Accessible", 1)).darker(.5));
        const borderline_texture = textures.lines().orientation("vertical").shapeRendering("crispEdges").size(2).lighter(2).stroke(d3.color(c(null, "Borderline", 1)).darker(0.5));
        const not_accessible_texture = textures.lines().orientation("6/8").shapeRendering("crispEdges").size(2).lighter(2).stroke(d3.color(c(null, "Not_Accessible", 1)).brighter(.5));
        
        accessibility_textures = {
            "Accessible": accessible_texture, 
            "Borderline": borderline_texture, 
            "Not_Accessible": not_accessible_texture
        };

        /* d3.select(viewerSvg)
            .call(accessible_texture)
            .call(borderline_texture)
            .call(not_accessible_texture) */
    })

    let accessibility_textures;

    async function load_db() {
        return (await db.second.toArray()).map(({id, annotation}) => {
            let res = JSON.parse(annotation)
            res.id = id;
            return res;
        });
    }

    //$: localStorage.setItem("annotations_second", JSON.stringify(annotations));

    let zoom = null;
    let transform = {
        "x": 0,
        "y": 0,
        "k": 1,
    };

    function zoomed({transform: T}) {
        transform = T;
        d3.select(viewerG).attr("transform", transform);
    }

    let viewerSvg;
    let viewerG;

    window.onresize = (event) => {
        event.stopPropagation();
        [width, height] = [window?.innerWidth, window?.innerHeight - 58]
    }

    function filename(i, suffix="_thumb") {
        const year = data[i].original_image.slice(0, 4)
        const condition = data[i].condition;
        const file = data[i].original_image.slice(5, -4);
        const file_end = data[i].original_image.slice(-3);
        const papertype = data[i].papertype;
        if (year == "2019") {
            const number_re = /\d+/;
            const number = number_re.exec(file)[0];
            if (isNaN(number)) console.log(file, number, `${window.location.href}data/all_images/${year}_300/thumb/${papertype}_${condition}_${number}_thumb.png`)
            return `${window.location.href}data/all_images/${year}_300/thumb/${papertype}_${condition}_${number}${suffix}.png`
        } else {
            return `${window.location.href}data/all_images/${year}_300/thumb/${file}_${condition}${suffix}.png`
        }
    }

    function filename_tooltip(i, original="no") {
        const year = data[i].original_image.slice(0, 4)
        const condition = data[i].condition;
        const file = data[i].original_image.slice(5, -4);
        const file_end = data[i].original_image.slice(-3);
        const papertype = data[i].papertype;
        if (year == "2019") {
            const number_re = /\d+/;
            const number = number_re.exec(file)[0];
            return original == "original" 
                ? `${window.location.href}data/all_images/${year}_300/outputImages/${condition}/${papertype}_${condition}_${number}.${file_end}`
                : `${window.location.href}data/all_images/${year}_300/Original/${papertype}-${number}.${file_end}`
        } else {
            return original == "original"
                ? `${window.location.href}data/all_images/${year}_300/outputImages/${condition}/${file}_${condition}.${file_end}`
                : `${window.location.href}data/all_images/${year}_300/Original/${file}.${file_end}`
        }
    }

    let legendSvg;
    $: draw_legend(colorBy)
    
    function draw_legend(t) {
        if (!legendSvg) return
        const svg = d3.select(legendSvg)
        const l = legend.legendColor()
            .labelFormat(d3.format(".2f"))
            //.useClass(true)
            .title(t)
            .titleWidth(100)
            .orient("vertical")
            .scale(scales[t])
            
        l(svg)

        //console.log(legendSvg.getBBox())
        d3.select(legendSvg.parentElement)
            .attr("width", legendSvg.getBBox().width + 2 * legend_margin)
            .attr("height", legendSvg.getBBox().height)

        
    }

    let showImages = false;

    let list = ["Accessible", "Borderline", "Not_Accessible"]

    let tooltip;
    let hovered = null;
    let mouse = {"x": 0, "y": 0};

    let showTooltip = 0;
    let rememberShowTooltip;

    let selectionTool = null;

    let annotations = [];
    let new_annotation = null;
    let selecting = false;

    let conditions = [];
    let filter_group = [];

    let hovered_annotation = null;
    let show_tooltip_annotation = false;
    let tooltip_annotation;
    let correlation_svg;

    $: update_annotation(tooltip_annotation)
    async function update_annotation(a) {
        if (a == null) return;
        //console.log("update_annotation")
        await db.second.update(a.id, {"annotation": JSON.stringify(tooltip_annotation)})
    }

    $: x_correlation = d3.scaleBand().domain(d3.range(0, all_names.length)).range([0, correlation_width]);
    $: x_correlation_linear = d3.scaleLinear().domain([0, all_names.length - 1]).range([0 + x_correlation.step() / 2, correlation_width - x_correlation.step() / 2])
    const c_correlation = d3.scaleSequentialSqrt(d3.interpolateRdGy).domain([-1, 1]);
    const correlation_width = 300;


    async function annotation_remove(event, id) {
        await db.second.where("id").equals(id).delete()
        annotations.splice(annotations.findIndex(a => a.id == id), 1);
        annotations = annotations;
    }

    function annotation_mouseenter(event, i) {
        hovered = null;
        hovered_annotation = i;
    }

    function annotation_mouseleave(event, i) {
        hovered_annotation = null;
    }

    function mousedown(event) {
        let {offsetX: mx, offsetY: my} = event;
        let tx = (mx - transform.x) / transform.k;
        let ty = (my - transform.y) / transform.k;

        if (selectionTool != null) {
            rememberShowTooltip = showTooltip;
            showTooltip = null;
            zoom.filter(() => false)
            if (selecting == false) {
                hovered = null;
                selecting = true
                new_annotation = {};
                if (selectionTool == 0) {
                    new_annotation.path = [[tx, ty]];
                } else if (selectionTool == 1) {
                    new_annotation.rect = {x1: tx, y1: ty, x2: tx, y2: ty};
                }                
            } 
        }

    }

    async function mouseup(event) {
        if (selecting) {
            zoom.filter(() => true);
            console.log("mouseup", selecting)
            selecting = false;
            let text = prompt("Please name the selection!", "Selection" + (annotations.length + 1))
            if (text) {
                new_annotation.text = text;
                new_annotation.gridify_with = gridify_with;
                new_annotation.projectionBy = projectionBy; 
                if (selectionTool == 0) {
                    const a = new_annotation;
                    new_annotation.data = data.filter((_, i) => {
                        const [px, py] = projection[i];
                        return d3.polygonContains(a.path, [x(px), y(py)])
                    });
                } else if (selectionTool == 1) {
                    const a = new_annotation;
                    new_annotation.data = data.filter((_, i) => {
                        const [px, py] = projection[i];
                        return x(px) > a.rect.x1 && x(px) <= a.rect.x2 && y(py) > a.rect.y1 && y(py) <= a.rect.y2;
                    });
                }
                const N = all_names.length;
                let X = druid.Matrix.from(new_annotation.data.map(row => all_names.map(key => row[key])));
                let C = new druid.Matrix(N, N, (i, j) => jStat.corrcoeff(X.col(i), X.col(j))).to2dArray.map(row => Array.from(row));
                C = druid.Matrix.from(C)
                const H = new druid.Hierarchical_Clustering(C, "complete");
                let {order, tree} = getTree(H);
                new_annotation.occurences = order.map(i => d3.mean(new_annotation.data, d => d[all_names[i]]));
                new_annotation.correlation = order.map(i => order.map(j => C.entry(i, j)))

                new_annotation.accessibility_correlation = order.slice()
                new_annotation.tree = tree;
                new_annotation.names = order.map(i => all_names[i]);
                new_annotation.id = await db.second.put({"annotation": JSON.stringify(new_annotation)})
                console.log("new annotation", new_annotation)
                annotations.push(new_annotation)
                annotations = annotations
            }

            selectionTool = null;
            showTooltip = rememberShowTooltip;
        }
        new_annotation = null;
    }

    function getTree(H, offsetX=0) {
        function getLeafs(node, res = []) {
            if (node.isLeaf) {
                res.push(node)
                return res;
            } 
            getLeafs(node.left, res)
            getLeafs(node.right, res)
            return res;
        }

        function getDescendants(node, res = []) {
            res.push(node)
            if (node.isLeaf) {
                return res;
            } 
            getDescendants(node.left, res)
            getDescendants(node.right, res)
            return res;
        }

        const leafs = getLeafs(H.root);
        leafs.forEach((node, i) => node.x = i + offsetX);
        
        const descendants = getDescendants(H.root);
        descendants.forEach((node, i) => {
            if (node.x == null) {
                node.x = d3.mean(getLeafs(node), ({x}) => x);
            }
        })

        const tree = [];
        descendants.forEach((node, i) => {
            const source = {};
            source.id = node.id;
            source.x = node.x;
            source.y = node.depth;
            source.isLeaf = node.isLeaf;

            for (const child of [node.left, node.right].filter(n => n)) {
                const target = {};
                target.id = child.id;
                target.x = child.x;
                target.y = child.depth;
                target.isLeaf = child.isLeaf;
                tree.push({
                    "source": source,
                    "target": target,
                })
            }
        })
        
        return {
            "order": leafs.map(({index}) => index),
            "tree": tree
        }
    }


    function mousemove(event) {
        if (!x || !projection) return;
        let {offsetX: mx, offsetY: my} = event;
        let tx = (mx - transform.x) / transform.k;
        let ty = (my - transform.y) / transform.k
        
        if (showTooltip != null) {
            mouse.x = mx;
            mouse.y = my;
            let i = delaunay.find(tx, ty);
            hovered = (Math.hypot(tx - x(projection[i][0]), ty - y(projection[i][1])) < 50) ? i : null;
            let w = 400;
            d3.select(tooltip)
                .style("top", event.clientY > window.innerHeight / 2 ? null : event.pageY + 15 + "px")
                .style("bottom", event.clientY > window.innerHeight / 2 ? (window.innerHeight - event.pageY) + 15 + "px" : null)
                .style("left", Math.min(Math.max(0, event.clientX - w / 2), window.innerWidth - w) + "px");
        } else {
            hovered = null;
        }

        if (selectionTool != null && selecting) {
            if (selectionTool == 0) {
                new_annotation.path.push([tx, ty])
                new_annotation = new_annotation;
            } else if (selectionTool == 1) {
                new_annotation.rect.x1 = Math.min(new_annotation.rect.x1, tx);
                new_annotation.rect.y1 = Math.min(new_annotation.rect.y1, ty);
                new_annotation.rect.x2 = Math.max(new_annotation.rect.x2, tx);
                new_annotation.rect.y2 = Math.max(new_annotation.rect.y2, ty);
            }
        }
    }

    function handleKeydown(event) {
        if (filter_has_focus) return;
        console.log(event.key)
        switch(event.key) {
            case "l": case "L": selectionTool = (selectionTool == 0 ? null : 0); break;
            case "r": case "R": selectionTool = (selectionTool == 1 ? null : 1); break;
            case "t": case "T": showTooltip = (showTooltip == 0 ? null : 0); hovered = null; break;
        }
    }

    function saveSvg(svgElement, filename) {
        svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        const svgData = svgElement.outerHTML;
        const preface = '<?xml version="1.0" standalone="no"?>\r\n';
        const svgBlob = new Blob([preface, svgData], {type:"image/svg+xml;charset=utf-8"});
        const svgUrl = URL.createObjectURL(svgBlob);
        const downloadLink = document.createElement("a");
        downloadLink.href = svgUrl;
        downloadLink.download = filename;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }

    let filterregex = false;
    let filterstring = "";
    let filter_has_focus = false;
    $: pattern = get_pattern(filterstring);
    $: console.log("regex", filterregex);

    function get_pattern(filterstring) {
        let res;
        try {
            res = new RegExp(filterstring)
        } catch(e) {
            res = null;
        }
        return res
    }
 
    function is_filtered(filterstring, i) {
        if (filterstring == "") return 1;
        let res;
        if (filterregex) {
            pattern = get_pattern(filterstring)
            res = pattern ? pattern.exec(data[i].original_image) : true
        } else {
            res = data[i].original_image.toLowerCase().includes(filterstring.toLowerCase())
        }
        return res ? true : false;
    }


    function draw_legend_tooltip(node) {
        const svg = d3.select(node)
        const l = legend.legendColor()
            .labelFormat(d3.format(".2f"))
            //.useClass(true)
            .title("Correlation")
            .titleWidth(100)
            .orient("vertical")
            .cells(17)
            .scale(c_correlation)
        
        l(svg);

        svg.selectAll(".swatch").each(function(d) {
            const add_rect = this.cloneNode()
            d3.select(add_rect)
                .style("fill", d < 0 ? "url(#neg)" : (d > 0 ? "url(#pos)": "none"))
            this.parentElement.appendChild(add_rect)
        })
        return {
            update() {
                l(svg);
            }
        }
    }



    function apply_textures(node, [index, rating]) {

        /* const copy = node.cloneNode();
        d3.select(copy).style("fill", accessibility_textures[rating].url())
        node.parentElement.appendChild(copy) */
        return {
            update() {

            }
        }
    }
</script>
<svelte:window on:keydown={handleKeydown}/>

<MaterialApp theme="light">
    <slot></slot>
    <AppBar absolute style="backdrop-filter: blur(10px); background-color: #fffa; border-radius: 0 0 .5rem 0; top: var(--s-app-bar-height);" class="pr-4">
        <slot name="title">
            <ButtonGroup tile activeClass="primary-color" bind:value={showTooltip}>
                <ButtonGroupItem><Icon path={mdiTooltip} /></ButtonGroupItem>
            </ButtonGroup>
            <span class="ml-4" />
            <ButtonGroup tile activeClass="primary-color" bind:value={selectionTool}>
                <ButtonGroupItem><Icon path={mdiLasso} /></ButtonGroupItem>
                <ButtonGroupItem><Icon path={mdiSelectDrag} /></ButtonGroupItem>
            </ButtonGroup>
            <span class="ml-4" />
            <ButtonGroup tile>
                <ButtonGroupItem on:click={async () => {
                                const data = await db.export({prettyJson: true})
                                console.log(data)
                                const a = document.createElement("a")
                                a.setAttribute("href", URL.createObjectURL(data))
                                a.setAttribute("download", "db.json")
                                a.style = "display:none"
                                document.body.appendChild(a);
                                a.click()
                                a.remove()
                                console.log(data)
                            }
                        }
                    >
                    <Icon path={mdiDatabaseExport}/>
                </ButtonGroupItem>
                <ButtonGroupItem on:click={async () => {
                                const input = document.createElement("input")
                                input.setAttribute("type", "file")
                                input.setAttribute("accept", ".json")
                                input.style = "display:none"
                                console.log(input)
                                document.body.appendChild(input)
                                input.onchange = async event => {
                                    console.log(event)
                                    console.log(event.target.files)
                                    const file = event.target.files[0];
                                    await db.delete();
                                    //db.open();
                                    db = await Dexie.import(file);
                                    annotations = await load_db();
                                    input.remove()
                                }
                                input.click()
                            }
                        }
                    >
                    <Icon path={mdiDatabaseImport}/>
                </ButtonGroupItem>
                <ButtonGroupItem on:click={async () => {
                    annotations = [];
                    await db.second.clear();
                }}><Icon path={mdiDatabaseRefresh}/></ButtonGroupItem>
            </ButtonGroup>
            <Divider vertical class="ml-4 mr-4" />
            <Switch bind:checked={filterregex}>Regex</Switch>
            <span class="ml-4" />
            <TextField 
                dense 
                clearable 
                solo 
                bind:value={filterstring} 
                placeholder="Filter"
                on:focus={() => filter_has_focus = true}
                on:blur={() => filter_has_focus = false}
                rules={[
                    (v) => (v && filterregex) ? pattern != null : true
                ]}
                >
                <div slot="prepend">
                    <Icon path={mdiFilter} />
                </div>                
            </TextField>
            <span class="ml-4" />
            <Button fab disabled={filterstring == ""} text
                on:click={async () => {
                    const text = prompt("Please name the selection!", "Selection" + (annotations.length + 1))
                    if (text) {   
                        let new_annotation = {
                            "text": text,
                            "data": data.filter((_, i) => is_filtered(filterstring, i)),
                        }
                        const N1 = issues_names.length;
                        let X1 = druid.Matrix.from(new_annotation.data.map(row => issues_names.map(key => row[key])));
                        let C1 = new druid.Matrix(N1, N1, (i, j) => jStat.corrcoeff(X1.col(i), X1.col(j))).to2dArray.map(row => Array.from(row));
                        C1 = druid.Matrix.from(C1)
                        const H1 = new druid.Hierarchical_Clustering(C1, "complete");
                        let {order: order1, tree: tree1} = getTree(H1);


                        const N2 = helpful_names.length;
                        let X2 = druid.Matrix.from(new_annotation.data.map(row => helpful_names.map(key => row[key])));
                        let C2 = new druid.Matrix(N2, N2, (i, j) => jStat.corrcoeff(X2.col(i), X2.col(j))).to2dArray.map(row => Array.from(row));
                        C2 = druid.Matrix.from(C2)
                        const H2 = new druid.Hierarchical_Clustering(C2, "complete");
                        let {order: order2, tree: tree2} = getTree(H2, N1);
                        

                        

                        let order = order1.concat(order2.map(d => d + order1.length));
                        let tree = tree1.concat(tree2);

                        const N = all_names.length;
                        let X = druid.Matrix.from(new_annotation.data.map(row => all_names.map(key => row[key])));
                        let C = new druid.Matrix(N, N, (i, j) => jStat.corrcoeff(X.col(i), X.col(j))).to2dArray.map(row => Array.from(row));
                        C = druid.Matrix.from(C)

                        let accessibility_row = new_annotation.data.map(row => d3.sum(["Not_Accessible", "Borderline", "Accessible"].map((key, i) => (i+1) * row[key])))
                        console.log(accessibility_row)
                        new_annotation.accessibility_correlation = order.map(i => jStat.corrcoeff(accessibility_row, new_annotation.data.map(row => row[all_names[i]])));
                        console.log(new_annotation.accessibility_correlation)
                        new_annotation.occurences = order.map(i => d3.mean(new_annotation.data, d => d[all_names[i]]));
                        new_annotation.correlation = order.map(i => order.map(j => C.entry(i, j)))
                        new_annotation.tree = tree;
                        new_annotation.names = order.map(i => all_names[i]);
                        new_annotation.id = await db.second.put({"annotation": JSON.stringify(new_annotation)})
                        console.log("new annotation", new_annotation)
                        annotations.push(new_annotation)
                        annotations = annotations
                    }
                }}>
                    <Icon path={mdiContentSave} />
            </Button>
            <span class="ml-2" />
            <Divider vertical class="ml-4 mr-4" />
            <ButtonGroup tile>
                <ButtonGroupItem on:click={() => saveSvg(viewerSvg, `projection_${projectionBy}_gridified_by_${gridify_with}_colored_by_${colorBy}.svg`)}>
                    <Icon path={mdiContentSave} /><span class="pl-3" />Save SVG
                </ButtonGroupItem>
            </ButtonGroup>
            <ButtonGroup tile>
                <span class="ml-4" />
                <label><input type="color" bind:value={accessible_color}/>A</label>
                <span class="ml-4" />
                <label><input type="color" bind:value={borderline_color}/>B</label>
                <span class="ml-4" />
                <label><input type="color" bind:value={not_accessible_color}/>N</label>
            </ButtonGroup>
            <span class="ml-4" />
            <Menu>
                <div slot="activator">
                    <ButtonGroup tile>
                        <Badge outlined class="primary-color" value={annotations.length}>
                            <ButtonGroupItem>
                                            Annotations
                            </ButtonGroupItem>
                        </Badge>
                    </ButtonGroup>
                </div>
                <List style="width: 350px;">
                    {#each annotations as a, i}
                        <ListItem on:click={() => {
                                show_tooltip_annotation = true;
                                tooltip_annotation = a;
                            }}>
                            {a.text}
                            <span slot="append">
                                <Button icon on:click={(event) => {
                                            event.stopPropagation();
                                            annotation_remove(event, a.id)
                                        }
                                    }>
                                    <Icon path={mdiDelete} />
                                </Button>
                            </span>
                            <!-- <span slot="prepend">
                                <Button icon><Icon path={mdiInformation} /></Button>
                            </span> -->
                            <span slot="subtitle">
                                has {a.data.filter((d) => filter_group.findIndex(f => f == d.condition) >= 0).length} elements
                            </span>
                        </ListItem>
                    {/each}
                </List>
            </Menu>
        </slot>
    </AppBar>
    <Container fluid bind:this={main} style="position: relative; height: calc(100vh - 58px);">
        <svg 
            width={width} 
            height={height} 
            shapeRendering="crispedges"
            bind:this={viewerSvg}
            on:mousedown|preventDefault={mousedown}
            on:mouseup|preventDefault={mouseup}
            on:mousemove|preventDefault={mousemove}>
            <g bind:this={viewerG}>
                {#each projection as p, i}
                    <g transform="translate({x(p[0])}, {y(p[1])})" opacity={is_filtered(filterstring, i) ? 1 : 0.2}>
                        {#if colorBy == "rating"}
                            {#each list as l, j}
                            <rect
                                x={1 + d3.sum(list.slice(0, j).map(k => data[i][k])) * w}
                                width={Math.max(0, data[i][l] * w)}
                                y=1
                                height={h + .5}
                                fill={c(null, l, 1)}
                                use:apply_textures={[i, l]}
                                >
                            
                            </rect>

                            {/each}
                        {:else}
                            <path d="M 0 0 v {h} h {w} v {-h} Z" fill={c(i, colorBy)}>
                                <!-- <title>{filename(i)}</title> -->
                            </path>
                        {/if}
                        {#if showImages}
                        <image 
                            pointer-events="none"
                            x=1
                            y=1
                            xlink:href={filename(i)}
                            width={w-2}
                            height={h-2}>
                        
                        </image>
                        {/if}
                    </g>
                {/each}

                <g>
                    {#if new_annotation}
                        {#if new_annotation.path}
                            <path 
                                class="moving"
                                d="M {new_annotation.path.join(" ")}"
                                fill="none"
                                stroke="black"
                                stroke-dasharray="2 2"
                                >
                            
                            </path>
                        {/if}
                        {#if new_annotation.rect}
                            <rect
                                class="moving"
                                x={new_annotation.rect.x1}
                                y={new_annotation.rect.y1}
                                width={new_annotation.rect.x2 - new_annotation.rect.x1}
                                height={new_annotation.rect.y2 - new_annotation.rect.y1}
                                fill="none"
                                stroke="black"
                                stroke-dasharray="2 2"
                                >

                            </rect>
                        {/if}
                    {/if}
                    {#each annotations as a, i}
                        {#if a.path}
                            <path 
                                d="M {a.path.join(" ")} Z"
                                fill="none"
                                stroke="black"
                                stroke-dasharray="2 2"
                                >
                            
                            </path>
                            <text 
                                x={d3.polygonCentroid(a.path)[0]}
                                y={d3.min(a.path, d => d[1]) - 10}
                                text-anchor="middle"
                                dominant-baseline="center"
                                >
                                {projection.filter(([px, py], i) => filter_group.findIndex(f => f == data[i].condition) >= 0 && d3.polygonContains(a.path, [x(px), y(py)])).length}× {a.text}
                            </text>
                            <g transform="translate({d3.polygonCentroid(a.path)[0]}, {d3.min(a.path, d => d[1]) - 10})">
                                <g transform="translate(-14, 0)">
                                    <path class="path-button" 
                                        on:mouseenter|preventDefault={(event) => annotation_mouseenter(event, i)} 
                                        on:mouseleave|preventDefault={(event) => annotation_mouseleave(event, i)} 
                                        on:mousemove|stopPropagation
                                        on:click|preventDefault|stopPropagation={(event) => {
                                                show_tooltip_annotation = true;
                                                tooltip_annotation = a;
                                            }
                                        }
                                        d={mdiInformation} />
                                </g>
                                <g transform="translate(14, 0)">
                                    <path class="path-button"
                                        on:click|preventDefault={(event) => annotation_remove(event, a.id)} 
                                        d={mdiDelete} />
                                </g>
                            </g>
                        {/if}
                        {#if a.rect}
                            <rect
                                x={a.rect.x1}
                                y={a.rect.y1}
                                width={a.rect.x2 - a.rect.x1}
                                height={a.rect.y2 - a.rect.y1}
                                fill="none"
                                stroke="black"
                                stroke-dasharray="2 2"
                                >

                            </rect>
                            <text 
                                x={(a.rect.x2 + a.rect.x1) / 2}
                                y={a.rect.y1 - 10}
                                text-anchor="middle"
                                dominant-baseline="center"
                                >
                                {projection.filter(([px, py], i) => filter_group.findIndex(f => f == data[i].condition) >= 0 && x(px) > a.rect.x1 && x(px) <= a.rect.x2 && y(py) > a.rect.y1 && y(py) <= a.rect.y2).length}× {a.text}
                            </text>
                            <g transform="translate({(a.rect.x2 + a.rect.x1) / 2}, {a.rect.y1 - 10})">
                                <g transform="translate(-14, 0)">
                                    <path class="path-button" 
                                        on:mouseenter|preventDefault={(event) => annotation_mouseenter(event, i)} 
                                        on:mouseleave|preventDefault={(event) => annotation_mouseleave(event, i)} 
                                        on:mousemove|stopPropagation
                                        on:click|preventDefault|stopPropagation={() => {
                                                show_tooltip_annotation = true;
                                                tooltip_annotation = a;
                                            }
                                        }
                                        d={mdiInformation} />
                                </g>
                                <g transform="translate(14, 0)">
                                    <path class="path-button"
                                        on:click|preventDefault={(event) => annotation_remove(event, a.id)} 
                                        d={mdiDelete} />
                                </g>
                            </g>
                        {/if}
                    {/each}
                </g>
            </g>

        </svg>
        <aside id="right">
            <div>
                <svg width=150>
                    <g transform="translate({legend_margin}, {legend_margin + 5})" bind:this={legendSvg}></g>
                </svg>
            </div>
        </aside>
        <aside id="left">
            <div>
                <Row>
                    <Col>
                        <Select 
                            dense
                            items={["all", "issues", "helpful"].map(k => {
                                return {"name": k, "value": k};
                            })} 
                            bind:value={projectionBy}>
                            <span slot="prepend-outer">
                              <Icon path={mdiCubeScan} />
                            </span>
                            projection by
                        </Select>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Select
                            dense
                            items={Object.keys(scales).slice(0, -3).map(k => {
                                return {"name": k, "value": k};
                            })}
                            bind:value={colorBy}>
                            <span slot="prepend-outer">
                              <Icon path={mdiPalette} />
                            </span>
                            color by
                        </Select>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Select
                            dense
                            items={["none", "hilbert", "dgrid"].map(k => {
                                return {"name": k, "value": k};
                            })}
                            bind:value={gridify_with}>
                            <span slot="prepend-outer">
                              <Icon path={mdiViewGrid} />
                            </span>
                            gridify with
                        </Select>
                    </Col>
                </Row>
                <Divider />
                <Subheader><Icon path={mdiFilter} />filter by</Subheader>
                <Row>
                    <Col>
                        {#each conditions as c}
                            <Switch dense bind:group={filter_group} value={c}>{c}</Switch>
                        {/each}
                    </Col>                    
                </Row>
                <Divider />
                <Row>
                    <Col>
                        <Checkbox bind:checked={showImages}>
                            show images
                        </Checkbox>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button on:click={() => d3.select(viewerG).call(zoom.transform, d3.zoomIdentity)} block><Icon path={mdiArrowExpandAll} class="mr-3"/>reset zoom</Button>
                    </Col>
                </Row>
            </div>
        </aside>

        <!-- <aside id="top-right">
            <div>
                <Row>
                    
                </Row>
            </div>

        </aside> -->

        <div id="tooltip"
            bind:this={tooltip}
            style="visibility: {hovered ? 'visible' : 'hidden'}; border-left: 1em solid {hovered}">
            {#if hovered}
            <div style="width: {400}px; padding-right: 1em;">
                <Subheader>{data[hovered].original_image}</Subheader>
                <Divider />
                <div style="max-height:400px; width:400px; display: flex; gap: 10px">
                    <div style="text-align: center; flex-grow: 1">
                        Original<br />
                        <img style="max-height: 200px; max-width: 195px; height: auto; width: auto; margin-top: 0.5rem" src="{filename_tooltip(hovered)}" alt=""/>
                    </div>
                    <div style="text-align: center; flex-grow: 1">
                        {data[hovered].condition}<br />
                        <img style="max-height: 200px; max-width: 195px; height: auto; width: auto; margin-top: 0.5rem" src="{filename_tooltip(hovered, "original")}" alt=""/>
                    </div>  
                </div>
            </div>
            {/if}
        </div>
    </Container>
    <Dialog bind:active={show_tooltip_annotation} width={"auto"}>
        <Card>
            <CardTitle>
                {tooltip_annotation.text}
                <div style="flex-grow:1" />
                <Button icon on:click={() => saveSvg(correlation_svg, `${tooltip_annotation.text}.svg`)}>
                    <Icon path={mdiContentSave} />
                </Button>
                <Button icon on:click={() => {
                            show_tooltip_annotation = false;
                            tooltip_annotation = null;
                        }
                    }>
                    <Icon path={mdiClose} />
                </Button>
            </CardTitle>
            <CardText>
                <Textarea outlined bind:value={tooltip_annotation.comment}
                    on:focus={() => filter_has_focus = true}
                    on:blue={() => filter_has_focus = false}
                    >
                    <span slot="prepend"><Icon path={mdiCommentTextOutline} /></span>
                    Comment
                </Textarea>
                <svg width={130 + correlation_width + 150} height={correlation_width + 130 + 80} bind:this={correlation_svg} font-family="sans-serif" font-size="10px">
                    <defs>
                        <pattern id="pos"
                            x="0" y="0" width="6.356382351524142" height="6.356382351524142"
                            patternUnits="userSpaceOnUse">
                        <path
                            style="stroke:white;stroke-width:0.25mm"
                            d="M -3.7795275590551185,3.7795275590551185 3.7795275590551185,-3.7795275590551185"/>
                        <path
                            style="stroke:white;stroke-width:0.25mm"
                            d="M -3.7795275590551185,10.135909910579262 10.135909910579262,-3.7795275590551185"/>
                        <path
                            style="stroke:white;stroke-width:0.25mm"
                            d="M 2.5768547924690237,10.135909910579262 10.135909910579262,2.5768547924690237"/>
                        </pattern>
                        <pattern id="neg"
                            x="0" y="0" width="6.356382351524142" height="6.356382351524142"
                            patternUnits="userSpaceOnUse">
                        <path
                            style="stroke:white;stroke-width:0.25mm"
                            d="M 2.5768547924690237,-3.7795275590551185 10.135909910579262,3.7795275590551185"/>
                        <path
                            style="stroke:white;stroke-width:0.25mm"
                            d="M -3.7795275590551185,-3.7795275590551185 10.135909910579262,10.135909910579262"/>
                        <path
                            style="stroke:white;stroke-width:0.25mm"
                            d="M -3.7795275590551185,2.5768547924690237 3.7795275590551185,10.135909910579262"/>
                        </pattern>
                    </defs>
                    <g transform="translate(130, {120})" shape-render="crispedges">
                        <text x={correlation_width + 10 + 9} y={-65 - (x_correlation.step() + 5)}>Occurences (in %)</text>
                        <!-- <text x=-9 y={correlation_width + 41} text-anchor="end" dominant-baseline="hanging">Occurences (in %)</text> -->
                        {#each tooltip_annotation.names as row, i}
                            
                            <!-- reihen -->
                            <g transform="translate(-9, {x_correlation.step() + 10 + (i >= issues_names.length ? 10 : 0)})">
                                <text font-family="sans-serif" x=0 y={x_correlation(i) + x_correlation.step() / 2} dominant-baseline="central" text-anchor="end">{names_dict[row]} <tspan font-family="monospace" font-weight="bold">{helpful_names.includes(row) ? "+" : "–"}</tspan></text>
                            </g>

                            <!-- Spalten -->
                            <!-- <g transform="translate({x_correlation(i) + x_correlation.step() / 2 + (i >= issues_names.length ? 10 : 0)}, {correlation_width + 12 + 45}) rotate(60)">
                                <text x={0} font-family="sans-serif" dominant-baseline="central" text-anchor="start">
                                    <tspan font-family="monospace" font-weight="bold">{helpful_names.includes(row) ? "+" : "–"}</tspan> {names_dict[row]}
                                </text>
                            </g> -->

                            <!-- Spalten oben -->
                            <g transform="translate({x_correlation(i) + x_correlation.step() / 2 + (i >= issues_names.length ? 10 : 0)}, {-9 - (x_correlation.step() + 5)}) rotate(-90)">
                                <text x={0} font-family="sans-serif" dominant-baseline="central" text-anchor="start">
                                    <tspan font-family="monospace" font-weight="bold">{helpful_names.includes(row) ? "+" : "–"}</tspan> {names_dict[row]}
                                </text>
                            </g>

                            <g transform="translate({i >= issues_names.length ? 10 : 0}, 0)">
                                {#each tooltip_annotation.names as col, j}
                                    <g transform="translate(0, {j >= issues_names.length ? 10 : 0})">
                                        <rect x={x_correlation(i) + 1} y={x_correlation(j) + 1} width={x_correlation.step() - 2} height={x_correlation.step() - 2} fill={c_correlation(tooltip_annotation.correlation[i][j])}>
                                            <title>{tooltip_annotation.correlation[i][j]}</title>
                                        </rect>
                                        <rect pointer-events="none" x={x_correlation(i) + 1} y={x_correlation(j) + 1} width={x_correlation.step() - 2} height={x_correlation.step() - 2} fill={tooltip_annotation.correlation[i][j] < 0 ? "url(#neg)" : "url(#pos)"}></rect>
                                    </g>
                                {/each}
                            </g>
                        {/each}

                        <g transform="translate(0, 0)">
                            {#each tooltip_annotation.accessibility_correlation as c, j}
                                <g transform="translate({j >= issues_names.length ? 10 : 0}, -{x_correlation.step() + 5})">
                                    <rect y={x_correlation(all_names.length) + 1} x={x_correlation(j) + 1} width={x_correlation.step() - 2} height={x_correlation.step() - 2} fill={c_correlation(c)}>
                                        <title>{c}</title>
                                    </rect>
                                    <rect pointer-events="none" y={x_correlation(all_names.length) + 1} x={x_correlation(j) + 1} width={x_correlation.step() - 2} height={x_correlation.step() - 2} fill={c < 0 ? "url(#neg)" : "url(#pos)"}></rect>
                                </g>
                            {/each}
                            <g transform="translate(-9, {x_correlation.step() / 2 - (x_correlation.step() + 5)})">
                                <text font-weight="bolder" text-anchor="end" dominant-baseline={"central"}>accessibility</text>
                            </g>
                        </g>

                        <!-- Occurences -->
                        {#each tooltip_annotation.occurences as o, i}
                            <g transform="translate({i >= issues_names.length ? 10 : 0}, {-55 - (x_correlation.step() + 5)})">
                                <path d="M {x_correlation(i) + 1} {-4} h {x_correlation.step() - 2} v {o * -50} h {-(x_correlation.step() - 2)}" fill="black">
                                    <title>{d3.format(".2f")(o)}</title>
                                </path>
                                <g transform="translate({x_correlation(i) + x_correlation.step() / 2}, {o * -50}) rotate(-90)">
                                    <text pointer-events="none" font-size="10px" x={Math.round(o * 100) > 60 ? -9 : 9} text-anchor={Math.round(o * 100) > 60 ? "end" : "start"} fill={Math.round(o * 100) > 60 ? "white" : null} dominant-baseline="central">{Math.round(o * 100)}</text>
                                </g>
                                <!-- <path d="M {-50} {x_correlation(i) + 1} v {x_correlation.step() - 2} h {o * 50} v {-(x_correlation.step() - 2)}" fill="black">
                                    <title>{d3.format(".2f")(o)}</title>
                                </path> -->
                            </g>
                        {/each}

                        <!-- Occurences unten -->
                        <!-- {#each tooltip_annotation.occurences as o, i}
                            <g transform="translate({i >= issues_names.length ? 10 : 0}, {correlation_width + 12 + 45})">
                                <path d="M {x_correlation(i) + 1} {-4} h {x_correlation.step() - 2} v {o * -50} h {-(x_correlation.step() - 2)}" fill="black">
                                    <title>{d3.format(".2f")(o)}</title>
                                </path>
                                <g transform="translate({x_correlation(i) + x_correlation.step() / 2}, {o * -50}) rotate(-90)">
                                    <text pointer-events="none" font-size="10px" x={Math.round(o * 100) > 60 ? -9 : 9} text-anchor={Math.round(o * 100) > 60 ? "end" : "start"} fill={Math.round(o * 100) > 60 ? "white" : null} dominant-baseline="central">{Math.round(o * 100)}</text>
                                </g>
                            </g>
                        {/each} -->


                    </g>
                    <g transform="translate(130, {50})">
                        <!-- {#each tooltip_annotation.tree as link, i}
                                <path d={d3.linkVertical().x(d => x_correlation_linear(d.x)).y(d => -d.y / d3.max(tooltip_annotation.tree, n => n.source.y) * 50)(link)} fill="none" stroke="black" />
                        {/each} -->
                    </g>
                    <g transform="translate({130 + correlation_width + 10}, {120})">
                        {#each tooltip_annotation.tree as {source, target}, i}
                            <g transform="translate(0, {source.x >= issues_names.length ? 10 : 0})">
                                <path d="M {source.y / d3.max(tooltip_annotation.tree, n => n.source.y) * 50} {x_correlation_linear(source.x)} L {source.y / d3.max(tooltip_annotation.tree, n => n.source.y) * 50} {x_correlation_linear(target.x)} L {target.y / d3.max(tooltip_annotation.tree, n => n.source.y) * 50} {x_correlation_linear(target.x)}" fill="none" stroke="black" />
                            </g>
                        {/each}
                    </g>
                    <g transform="translate({130 + correlation_width + 50 + 24 + 10}, {120})" use:draw_legend_tooltip>
                    
                    </g>
                </svg>
                <Subheader>Images</Subheader>
                <Row style="width: {130 + correlation_width + 150}px;" noGutters>
                    {#each tooltip_annotation.data as a}
                        <Col cols=3 class="text-center">
                            <small>{a.condition}</small><br />
                            <img width="{(130 + correlation_width + 150) / 4}px" src={filename_tooltip(a.iii, a.condition == "original" ? "no" : "original")} alt={a.iii} />
                        </Col>
                    {/each}
                </Row>
            </CardText>
            <CardActions>
                <div style="flex-grow:1" />
                <Button icon on:click={(event) => {
                            event.stopPropagation();
                            annotation_remove(event, tooltip_annotation.id)
                            show_tooltip_annotation = false;
                            tooltip_annotation = null;
                        }
                    }>
                    <Icon path={mdiDelete} />
                </Button>
            </CardActions>
        </Card>        
    </Dialog>
</MaterialApp>

<style>
    #right {
        position: absolute;
        bottom: 0rem;
        right: 0rem;
        padding: 0rem;
    }

    #left {
        position: absolute;
        bottom: 0rem;
        left: 0rem;
        padding: 0rem;
    }

    aside > div {
        background-color: #fffc;
        backdrop-filter: blur(10px);
        padding: 1rem;
    }

    #right > div {
        border-radius: .5rem 0 0 0;
    }

    #left > div {
        border-radius: 0 .5rem 0 0;
    }

    path {
        transition: fill 0.5s ease-in-out;
    }

    .path-button:hover {
        fill: var(--theme-text-link) !important;
    }

    #tooltip {
        font-size: 0.8rem;
        display: flex;
        position: absolute;
        pointer-events: none;
        padding: 1rem;
        background-color: #fffc;
        color: black;
        backdrop-filter: blur(20px);
        box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
        border-radius: .5rem;
        z-index: 99999;
    }

    .moving {
        animation: dash 5s linear infinite;
    }

    @keyframes dash {
        to {
            stroke-dashoffset: 60;
        }
    }
</style>